export type UseOpenGraphArticleProps = {
  enabled: boolean;
  pageAuthor?: string;
  pageKeywords?: Array<string> | string;
  pageModifiedDate?: string;
  pagePublishedDate?: string;
  section?: string;
}

/**
 * Open Graph Article hook
 * https://ogp.me/#type_article÷
 * @param param0 
 * @returns 
 */
export function useOpenGraphArticle({
  enabled,
  pageAuthor,
  pageKeywords,
  pageModifiedDate,
  pagePublishedDate,
  section
}: UseOpenGraphArticleProps) {
  if (!enabled) {
    return <></>
  }

  const parseKeywords = () => {
    if (typeof pageKeywords === 'string') {
      return pageKeywords.split(', ').map((i, k) => <meta key={`og_article_keywords_${i}${k}`} property='article:tag' content={i} />)
    }
    if (Array.isArray(pageKeywords)) {
      return pageKeywords.map((i, k) => <meta key={`og_article_keywords_${i}${k}`} property='article:tag' content={i} />)
    }
  }

  return (
    <>
      {pageModifiedDate && <meta key='og_article_modified_time' property='article:modified_time' content={pageModifiedDate} />}
      {pagePublishedDate && <meta key='og_article_published_time' property='article:published_time' content={pagePublishedDate} />}
      {pageAuthor && <meta key='og_article_author' property='article:author' content={pageAuthor} />}
      {pageKeywords && parseKeywords()}
      {section && <meta key='og_article_section' property='article:section' name='article:section' content={section} />}
    </>
  )
}